<template>
  <div class="UserManage">
        <div>
        <el-radio-group v-model="radio" size="small" @change="SelectPage">
            <el-radio-button label="1" >总后台用户</el-radio-button>
            <el-radio-button label="2">后台用户</el-radio-button>
            <el-radio-button label="3">外部用户</el-radio-button>
        </el-radio-group>
        </div>
        <div style="margin-top:15px;">
          <el-form ref="ruleForm" label-width="100px">
                <el-row>
                    <el-col :span="5" v-if="this.radio == 2">
                        <el-form-item label="选择分公司">
                            <el-select v-model="ruleForm.branch" filterable placeholder="请选择">
                                <el-option
                                    v-for="item in branchList"
                                    :key="item.id"
                                    :label="item.companyFullName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" v-if="this.radio == 3">
                        <el-form-item label="选择子公司">
                            <el-select v-model="ruleForm.subsidiary" filterable placeholder="请选择">
                                <el-option
                                    v-for="item in subsidiaryList"
                                    :key="item.id"
                                    :label="item.companyFullName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="开始日期">
                            <el-date-picker
                                v-model="ruleForm.starttime"
                                type="date"
                                @change="startDate"
                                placeholder="选择开始日期"
                                format="yyyy-MM-dd HH:mm:ss"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="结束日期">
                            <el-date-picker
                                v-model="ruleForm.endtime"
                                type="date"
                                @change="endDate"
                                placeholder="选择结束日期"
                                format="yyyy-MM-dd HH:mm:ss"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label class="search">
                            <el-input v-model="ruleForm.input" placeholder="姓名、账号" style="width: 60%;"></el-input>
                            <el-button type="primary" style="margin-left: 15px;" @click="search2">搜索</el-button>
                            <el-button type="primary" @click="searchReset">重置</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div>
            <el-table :data="tableData" border style="width: 100%" v-loading="loading">
                    <el-table-column align="center" type="index" width="50" label="ID"></el-table-column>
                    <el-table-column align="center" label="头像" width="100">
                        <template slot-scope="scope">
                            <div v-if="scope.row.headPortrait !== null">
                                <el-popover trigger="hover" placement="right" style="float: left;">
                                    <img :src="scope.row.headPortrait" alt class="prduct_img"/>
                                    <div class="scope_img" slot="reference">
                                        <img :src="scope.row.headPortrait" alt class="scope_img"/>
                                    </div>
                                </el-popover>
                            </div>
                            <div slot="error" class="image-slot" v-if="scope.row.headPortrait == null">
                                <img src="../assets/imags/暂无头像.png" alt="" style="width:80px;height:80px;">
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="userName" label="姓名" width="110"></el-table-column>
                    <el-table-column align="center" prop="telephone" label="电话" width="200"></el-table-column>
                    <el-table-column align="center" prop="qq" label="QQ" width="200"></el-table-column>
                    <el-table-column align="center" prop="date" label="注册时间"></el-table-column>
                    <el-table-column align="center" prop="currentPrice" label="角色">
                        <template slot-scope="scope">
                            <el-collapse>
                            <el-collapse-item :title="scope.row.companyRoleUserName0" name="1">
                                <div  v-for="item in scope.row.companyRoleUserNameList">{{item}}</div>
                            </el-collapse-item>
                            </el-collapse>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作" width="170">
                        <template slot-scope="scope">
                            <el-button @click="Edit(scope.row)" type="primary" icon="el-icon-view"></el-button>
                        </template>
                    </el-table-column>
            </el-table>
        </div>

        <el-dialog title="用户信息" :visible.sync="UserInformation" width="40%">
            <div class="box">
                <div>
                    <img :src="UserMain.headPortrait" alt="" v-if="UserMain.headPortrait !== null" style="width:230px;height:230px;">
                    <img src="../assets/imags/暂无头像.png" alt="" v-if="UserMain.headPortrait == null" style="width:230px;height:230px;">
                </div>
                
                <div style="margin-left:30px;">
                    <h2>{{UserMain.userName}}</h2>
                    <h4 style="margin-top:15px;">
                        性别：
                        <span v-if="UserMain.gender == 1">男</span>
                        <span v-if="UserMain.gender == 2">女</span>
                    </h4>
                    <h4 style="margin-top:15px;">手机号：{{UserMain.telephone}}</h4>
                    <h4 style="margin-top:15px;">QQ号：{{UserMain.qq}}</h4>
                    <h4 style="margin-top:15px;">邮箱：{{UserMain.email}}</h4>
                    <h4 style="margin-top:15px;">生日：{{UserMain.birthday}}</h4>
                    <h4 style="margin-top:15px;">所在地：{{UserMain.address}}</h4>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="UserInformation = false">关闭</el-button>
            </span>
        </el-dialog>

        <div class="page">
                <el-pagination
                    style="margin-right:200px;"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[20, 50, 100, 200]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
        </div>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from "../api/api/api";
export default {
    name: "UserManage",
    data() {
        return {
            str:"",
            radio:1,
            loading:true,
            UserInformation:false,
            UserMain:"",
            ruleForm:{
                starttime:"",
                endtime:"",
                branch:"",
                subsidiary:"",
                input:""
            },
            tableData:[],
            branchList:[],
            subsidiaryList:[],

            currentPage: 1,
            pagesize: 20,
            size: 20,
            total: 0,

        };
    },
    created() {
        this.str = JSON.parse(localStorage.getItem("role"));
        this.search()
    },
    methods: {
        SelectPage(val){
            if(val == 1){
                this.ruleForm.branch = ""
                this.ruleForm.subsidiary = ""
            }
            else if(val == 2){
                this.ruleForm.subsidiary = ""
                this.BranchAjax()
            }else if(val == 3){
                this.ruleForm.branch = ""
                this.SubsidiaryAjax()
            }
            this.search()
        },
        BranchAjax(){
            ajaxPost(Baseurl + "logisticsController/getAllBranchCompany").then(res => {
                if(res.data.code == 200){
                    this.branchList = res.data.data
                }
            });
        },
        SubsidiaryAjax(){
            ajaxPost(Baseurl + "unknownManageController/selectAllSubCompany").then(res => {
                if(res.data.code == 200){
                    this.subsidiaryList = res.data.data
                }
            });
        },
        search2(){
            this.currentPage = 1
            this.search()
        },
        search(){
            this.loading = true
                var obj = {
                    type:this.radio,
                    page:this.currentPage,
                    size:this.size,
                    branchCompanyId:this.ruleForm.branch,
                    companyId:this.ruleForm.subsidiary,
                    startTime:this.ruleForm.starttime,
                    endTime:this.ruleForm.endtime,
                    searchString:this.ruleForm.input
                };
                ajaxPost(Baseurl + "userControllers/selectUserListByCompanyType",obj).then(res => {
                    if(res.data.code == 200){
                        this.tableData = res.data.data.list
                        this.total = res.data.data.total
                    }
                    this.loading = false
                });
        },
        searchReset(){
            this.ruleForm.branch = ""
            this.ruleForm.subsidiary = ""
            this.ruleForm.starttime = ""
            this.ruleForm.endtime = ""
            this.ruleForm.input = ""
            this.search()
        },
        Edit(val){
            this.UserInformation = true
            this.UserMain = val
            console.log(val)
        },
        startDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 00:00:00";
            this.ruleForm.starttime = datetime;
        },
        //选择结束日期
        endDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 23:59:59";
            this.ruleForm.endtime = datetime;
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.size = val;
            this.search()
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.currentPage = val;
            this.search()
        },
    }
}
</script>
<style lang="scss" scoped>
/deep/ {
    .search .el-form-item__content{
        margin-left: 0px!important;
    }
    .el-collapse {
        border-top: none;
        border-bottom: none;
    }
    .el-collapse-item__header {
        border-bottom: none;
        background: none !important;
    }
    .el-collapse-item__wrap {
        border-bottom: none;
        background: none !important;
    }
    .el-collapse-item__content {
        padding-bottom: 0px;
    }
}
</style>
<style lang="scss" scoped>
.UserManage{
    margin-bottom: 50px;
}
.box{
    display: flex;
    justify-content: left;
}
.prduct_img {
    width: 500px;
    height: 500px;
}
.scope_img {
    width: 80px;
    height: 80px;
    img {
        width: 100%;
        height: 100%;
    }
}
.page {
    position: fixed;
    width: 100%;
    bottom: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
}
</style>